import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';
import _ from 'lodash';

import { api } from '@/api';
import { DefaultValues, Option } from '@/common/types';
import { API_URL, IFileActorDto } from '@/dtos';

const GET_ORGANIZATION_KEY = 'useOrganizationsContact';

const SEARCH_LEN = 3;
const getOrganizations = (searchValue: string) => () =>
  api.get(API_URL.FILES_FILE_ACTORS, {
    params: {
      ...(searchValue && searchValue?.length >= SEARCH_LEN ? { search_value: searchValue } : {}),
    },
  });

const MAX_CASHED_FILES = 15;

const useOrganizationQuery = (searchValue: string, additionalFetchParams?: DefaultValues) => {
  const [isLocalSearch, setLocalSearch] = useState(false);
  const [localSearchResult, setLocalSEarchResult] = useState<IFileActorDto[]>([]);

  const { isLoading, data, isSuccess } = useQuery(
    [
      GET_ORGANIZATION_KEY,
      searchValue && searchValue?.length >= SEARCH_LEN ? searchValue : '',
      additionalFetchParams?.observingOrganizationPath,
      isLocalSearch,
    ],
    getOrganizations(searchValue),
    {
      enabled:
        additionalFetchParams?.enabled || additionalFetchParams?.enabled === undefined
          ? !isLocalSearch
          : false,
    }
  );
  useEffect(() => {
    if (!_.trim(searchValue) && data?.data?.length && data?.data?.length < MAX_CASHED_FILES) {
      setLocalSearch(true);
      setLocalSEarchResult(data?.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.data?.length]);

  useEffect(() => {
    setLocalSearch(false);
    setLocalSEarchResult([]);
  }, [additionalFetchParams?.observingOrganizationPath]);
  const formattedData = useMemo<Option[]>(() => {
    const list = isLocalSearch ? localSearchResult : data?.data || [];

    return list.map((item) => {
      const fullName = `${item.name}`.trim();

      return {
        key: toString(item.id),
        value: fullName,
        title: fullName,
      };
    });
  }, [data?.data, isLocalSearch, localSearchResult]);

  return {
    data: formattedData,
    isLoading,
    isSuccess,
  };
};

export default useOrganizationQuery;
